import m, {Vnode, VnodeDOM} from "mithril";
import {TextareaItem} from "../../../../model/items/textarea";
import {progressBarThermometerView} from "../../../../ui/items/progressBarThermometer";
import SpeechToText from "../SpeechToText/SpeechToText";

export default class TextInputCell {

    private focused = false;
    public readonly speechToText: SpeechToText|null = null;

    constructor(
        public readonly textarea: TextareaItem,
        public readonly enableSpeechToText: boolean = false
    ) {
        if (enableSpeechToText && SpeechToText.isSpeechRecognitionSupported()) {
            this.speechToText = new SpeechToText(this.textarea);
        }
    }

    public view(): Vnode|null {

        if (!this.textarea.cell.visible) {
            return null;
        }

        const cssClass = 'TextareaCell' + (this.textarea.cell.cssClass ? (' '+this.textarea.cell.cssClass) : '');

        return m("div", {
            "class": cssClass
        }, [
            m('textarea', {
                id: this.textarea.variableName,
                autocomplete: 'off',
                tabindex: 1,
                disabled: !this.textarea.cell.enabled,
                onfocus: () => this.focused = true,
                onblur: () => this.focused = false,
                oninput: (e: Event) => this.textarea.set((<HTMLInputElement>e.currentTarget).value),
            }, this.focused ? undefined : this.textarea.getVariable()),
            this.speechToText ? m(this.speechToText) : null,
            progressBarThermometerView(this.textarea),
        ]);
    }

    oncreate(vnode: VnodeDOM) {
        $(vnode.dom).find('textarea').val(this.textarea.getVariable());
    }
}